export default {
  transaction: {
    title: 'لین دین',
    select: 'منتخب کریں',
    all: 'تمام',
    loading: 'لوڈ ہو رہا ہے...',
    noMoreData: 'مزید ڈیٹا نہیں',
    mockSuccess: 'فرضی کامیابی',
    mockFail: 'فرضی ناکامی',
    mockSuccessDone: 'فرضی کامیابی مکمل',
    mockFailDone: 'فرضی ناکامی مکمل',
    mockFailed: 'فرضی عمل ناکام',
    today: 'آج',
    yesterday: 'کل',
    last3Days: 'پچھلے 3 دن',
    last7Days: 'پچھلے 7 دن',
    last15Days: 'پچھلے 15 دن',
    last30Days: 'پچھلے 30 دن',
    allTypes: 'تمام اقسام',
    deposit: 'ڈپازٹ',
    withdrawal: 'رقم نکالنا',
    withdrawalRefund: 'رقم نکالنے کی واپسی',
    bet: 'شرط',
    win: 'جیت',
    manualAdd: 'دستی اضافہ',
    manualSubtract: 'دستی کٹوتی',
    commission: 'کمیشن',
    bonus: 'بونس',
    vipUpgradeReward: 'وی آئی پی اپ گریڈ انعام',
    vipSalary: 'وی آئی پی تنخواہ',
    gameOutPrincipal: 'گیم آؤٹ - اصل رقم',
    gameOutBonus: 'گیم آؤٹ - بونس',
    bonusTransferOut: 'بونس منتقلی',
    allStats: 'تمام حالتیں',
    underReview: 'زیر جائزہ',
    pendingPayout: 'ادائیگی زیر التوا',
    successful: 'کامیاب',
    failed: 'ناکام',
    cancelled: 'منسوخ',
    processing: 'کارروائی جاری',
  },
};
